import styled from "styled-components"

import exportIcon from "assets/svg/export-icon.svg"

import { ButtonNew } from "components/form/ButtonNew"

const StyledExportButton = styled(ButtonNew)`
  margin: 0 6px;

  @media only screen and (max-width: 768px) {
    border-radius: 8px;
    height: 34px;
    width: 34px;

    span {
      display: none;
    }

    &:after {
      content: "";
      position: absolute;
      display: inline-block;
      width: 20px;
      height: 20px;
      background-image: url("${exportIcon}");
      background-size: contain;
    }
  }
`

interface ExportButtonProps {
  disabled?: boolean
  onClick: () => void
}

const ExportButton = ({ disabled, onClick }: ExportButtonProps) => {
  return (
    <StyledExportButton onClick={onClick} disabled={disabled}>
      <span>Export</span>
    </StyledExportButton>
  )
}

export default ExportButton
